import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAccessManifest } from '../../context/AccessManifestContext';
import { isOfflineSessionToken } from '../../utils/offlineAuth';

function RequireCapability({ capability, anyOf, children }) {
  const { loaded, hasCapability } = useAccessManifest();
  const location = useLocation();

  const required = Array.isArray(anyOf) && anyOf.length
    ? anyOf
    : capability
      ? [capability]
      : [];

  if (!loaded) {
    return (
      <div style={{ minHeight: '40vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading access...</span>
        </div>
      </div>
    );
  }

  const allowed =
    required.length === 0 || required.some((cap) => hasCapability(cap));

  if (!allowed) {
    const token = (() => {
      try {
        return localStorage.getItem('token');
      } catch {
        return null;
      }
    })();
    const isOfflineSession = isOfflineSessionToken(token);
    // Drill Progress Map is the only fully offline-capable route today; accept
    // both the new /drilling/progress-map URL and the legacy /operations/field-operations
    // path so offline sessions on bookmarked URLs still resolve (R32 deprecation window).
    const isProgressMapRoute =
      location.pathname === '/drilling/progress-map' ||
      location.pathname === '/operations/field-operations';
    if (isOfflineSession && isProgressMapRoute) {
      return children;
    }
  }

  if (!allowed) {
    return <Navigate to="/app" replace />;
  }

  return children;
}

export default RequireCapability;
